import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from "@tanstack/react-query";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react"; // Import PersistGate
import { store, persistor } from "./redux/store"; // Import persistor
import { queryClient } from "./queryClient";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');

// Public pages hide the system cursor for the spotlight effect. Prerender can
// freeze `cursor: none` onto <body>, and private routes reuse that HTML.
if (document.body) {
  document.body.style.removeProperty("cursor");
}

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
              <App />
            </GoogleOAuthProvider>
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

// If the HTML already contains prerendered content served by the CDN, the
// client-side React tree can differ from the prerendered HTML (async data,
// animation initial states, etc.), which breaks hydration and leaves stale DOM
// on route changes. Use a full client render so React owns the DOM and
// navigation unmounts routes correctly. Crawlers still receive the
// prerendered HTML.
const root = ReactDOM.createRoot(rootElement);
root.render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
